// Board configuration - hardcoded for now, will sync from external DB later

export interface Team {
  id: string;
  name: string;
  pods: Pod[];
}

export interface Pod {
  id: string;
  name: string;
}

export interface UserAssignment {
  odz: string; // user email or ID
  teamId: string;
  podId: string;
}

// Teams and their pods
export const TEAMS: Team[] = [
  {
    id: "team-a",
    name: "Team Alpha",
    pods: [
      { id: "pod-a1", name: "Pod Alpha-1" },
      { id: "pod-a2", name: "Pod Alpha-2" },
    ],
  },
  {
    id: "team-b",
    name: "Team Beta",
    pods: [
      { id: "pod-b1", name: "Pod Beta-1" },
      { id: "pod-b2", name: "Pod Beta-2" },
    ],
  },
];

// User assignments - maps user to their team/pod
// This would come from external DB later
export const USER_ASSIGNMENTS: UserAssignment[] = [
  // Example assignments - add real users here
  { odz: "user@example.com", teamId: "team-a", podId: "pod-a1" },
];

// Default content for boards (rich text HTML)
export const DEFAULT_BOARD_CONTENT: Record<string, string> = {
  general: `<ul>
    <li>Happy birthday Maeve!</li>
    <li>Marty Shook OOO Apr. 8-12</li>
  </ul>`,
  "team-a": `<ul>
    <li>Team Alpha standup at 9am daily</li>
    <li>Sprint review Friday 3pm</li>
  </ul>`,
  "team-b": `<ul>
    <li>Team Beta planning Monday 10am</li>
    <li>Demo scheduled for next week</li>
  </ul>`,
  "pod-a1": `<ul>
    <li>Pod Alpha-1 focus: Frontend components</li>
    <li>Code review rotation updated</li>
  </ul>`,
  "pod-a2": `<ul>
    <li>Pod Alpha-2 focus: API development</li>
    <li>New endpoints ready for testing</li>
  </ul>`,
  "pod-b1": `<ul>
    <li>Pod Beta-1 focus: Infrastructure</li>
    <li>Deployment pipeline updates</li>
  </ul>`,
  "pod-b2": `<ul>
    <li>Pod Beta-2 focus: QA</li>
    <li>Test coverage goals for Q1</li>
  </ul>`,
};

// Helper to get user's assigned team and pod
export function getUserAssignment(userId: string): { team: Team | null; pod: Pod | null } {
  const assignment = USER_ASSIGNMENTS.find((a) => a.odz === userId);

  if (!assignment) {
    // Default: show first team and first pod for unassigned users
    const defaultTeam = TEAMS[0];
    return {
      team: defaultTeam || null,
      pod: defaultTeam?.pods[0] || null,
    };
  }

  const team = TEAMS.find((t) => t.id === assignment.teamId) || null;
  const pod = team?.pods.find((p) => p.id === assignment.podId) || null;

  return { team, pod };
}

// Get boards to display for a user
export function getUserBoards(userId: string): { id: string; title: string; type: "general" | "team" | "pod" }[] {
  const { team, pod } = getUserAssignment(userId);

  const boards: { id: string; title: string; type: "general" | "team" | "pod" }[] = [
    { id: "general", title: "General Board", type: "general" },
  ];

  if (team) {
    boards.push({ id: team.id, title: `${team.name} Board`, type: "team" });
  }

  if (pod) {
    boards.push({ id: pod.id, title: `${pod.name} Board`, type: "pod" });
  }

  return boards;
}
